import request from '@/request/index'
import JSEncrypt from 'jsencrypt'
import qs from 'qs'
const encryptPassword = (input) => {
  const encrypt = new JSEncrypt({})
  const publicKey =
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCoWhWwALKnLJhXL4ejr9ePxCMCM0sD7yEJGZg6cilzx524JNQ6tMvcKtEk0c2+o+DdYsHVxXKgh+Kn6fFoJ4vjuUdaI1e17SAb1cF71R2JAzQr7B4QAYbO2JoRpI0nu18EZG9ga6D03a8UMrAiTvRSMnL44fOznnxROlj9c/HbHwIDAQAB'
  encrypt.setPublicKey(publicKey)
  const output = encrypt.encrypt(input)

  return output || input
}

export function loginByPassword(req) {
  const { username, password } = req
  // 密码中混有时间戳进行RSA加密
  const lastParam = encryptPassword(
    JSON.stringify({
      password: password.replace(/\s/g, ''),
      timestamp: new Date().getTime()
    })
  )
  const data = {
    username: username.replace(/\s/g, ''),
    password: lastParam
  }
  return request({
    url: `/api/sys/v1/sso/loginV3`,
    method: 'Post',
    data
  })
}

/**
 * 获取用户信息
 * @returns {*}
 */
export function getUserInfo() {
  const params = {
    projectType: process.env.VUE_APP_PROJECT_TYPE
  }
  const data = qs.stringify(params, { arrayFormat: 'brackets' })
  return request({
    url: `/api/sys/v1/sys/users/current-user-simple?${data}`,
    method: 'Get'
  })
}

/**
 * 获得用户按钮权限
 * @returns {*}
 */
export function getButtons(req) {
  return request({
    url: `/api/sys/v1/sys/users/${req}/permissions`,
    method: 'GET'
  })
}
/**
 * 获取用户有权限的菜单
 * @returns {*}
 */
export function getMenuTree() {
  return request({
    url: `/api/v1/sys/user/menuTree`,
    method: 'Get'
  })
}

/**
 * 获取App菜单
 * @returns {*}
 */
export const getAppMenu = () => {
  return request({
    url: `/api/sys/v1/sys/users/menus/app`,
    method: 'Get'
  })
}
